import { render, staticRenderFns } from "./heavy-vehicles.vue?vue&type=template&id=63cad29f&scoped=true"
import script from "./heavy-vehicles.vue?vue&type=script&lang=js"
export * from "./heavy-vehicles.vue?vue&type=script&lang=js"
import style0 from "./heavy-vehicles.vue?vue&type=style&index=0&id=63cad29f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cad29f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubNav: require('/app/components/SubNav.vue').default,Sticky: require('/app/components/Sticky.vue').default,Anchor: require('/app/components/Anchor.vue').default})
